@if (shouldBeAbleToEditListGroupItem) {
  <div class="app-input">
    <!-- WCAG 3.3.2 — label for must match combobox input id (NgSelectA11y sets id on inner input) -->
    @if (inputTitle) {
      <label [attr.for]="effectiveInputId" [attr.id]="effectiveInputId + '-a11y-label'">{{ inputTitle }}</label>
    }
    <!-- WCAG 4.1.3 (Deque 2168938) — announce loading state to screen readers without moving focus -->
    <div class="cdk-visually-hidden" role="status" aria-live="polite" aria-atomic="true">{{ isLoading ? ('A11Y_COMBOBOX_LOADING' | translate) : '' }}</div>
    <ng-select
      appNgSelectA11y
      [ngSelectA11yId]="effectiveInputId"
      [ngSelectA11yLabelledBy]="inputTitle ? effectiveInputId + '-a11y-label' : undefined"
      [appNgSelectA11y]="inputTitle || (placeholder | translate)"
      [clearable]="true"
      [items]="items"
      [(ngModel)]="selectedItem"
      [compareWith]="compareWith"
      [notFoundText]="'NO_ITEMS_FOUND' | translate"
      [bindLabel]="'label'"
      [bindValue]="'value'"
      [loading]="isLoading"
      [placeholder]="placeholder | translate"
      [appendTo]="'body'"
      [inputAttrs]="{ autocomplete: 'off' }"
      (change)="onChange($event)"
      (open)="onOpen()"
      (search)="onSearch($event)"
      [disabled]="!shouldBeAbleToEditListGroupItem"
      >
      <ng-template ng-option-tmp let-item="item" let-index="index">
        {{ item.extraLabels.firstLabel }}
        {{ item.extraLabels.secondLabel }}<br />
        <small>{{ item.extraLabels.thirdLabel ?? item.extraLabels.fourthLabel }}</small>
      </ng-template>
      <!-- WCAG 4.1.3 — role="alert" announces "no items found" to screen readers (Deque status-msg-not-auto-announced) -->
      <ng-template ng-notfound-tmp>
        <div class="ng-option disabled" role="alert" aria-atomic="true">{{ 'NO_ITEMS_FOUND' | translate }}</div>
      </ng-template>
    </ng-select>
  </div>
} @else {
  <div class="alert py-1" role="status" aria-live="polite">
    {{ notAbleToEditListGroupItemLabel | translate }}
  </div>
}


@if (shouldShowSelectedItemsList) {
  <ul class="list-group list-group-remove"  ngClass={{customListClass}}>
    @for (item of selectedItems; track item) {
      <li
        class="list-group-item d-flex align-items-center flex-wrap"
        tabindex="0"
    [attr.aria-label]="
      (item.extraLabels.firstLabel + ' ' + item.extraLabels.secondLabel + ' ' + (item.extraLabels.thirdLabel ?? item.extraLabels.fourthLabel ?? '')).trim()
    "
        (click)="onItemClick(item)"
        (keydown.enter)="onItemClick(item)"
        (keydown.space)="$event.preventDefault(); onItemClick(item)"
        >
        <span class="btn btn-link text-body text-left flex-grow-1 p-0 m-0 border-0 text-decoration-none">
          <b class="mr-3">{{ item.extraLabels.firstLabel }} {{ item.extraLabels.secondLabel }}</b>
          {{ item.extraLabels.thirdLabel ?? item.extraLabels.fourthLabel }}
        </span>
        <span class="d-flex ml-auto align-items-center flex-shrink-0 pl-1">
          <span class="d-flex align-items-center">
            <i class="{{ item.extraLabels.metaDataCountIcon }}" aria-hidden="true"></i>
            <span class="ml-1">{{ item.extraLabels.metaDataCount }}</span>
          </span>
          @if (shouldBeAbleToEditListGroupItem) {
            <button
              type="button"
              class="round-btn round-btn-xs list-group-action ml-1"
              (click)="$event.stopPropagation(); onRemove(item)"
              (keydown.enter)="$event.stopPropagation()"
              (keydown.space)="$event.stopPropagation()"
              [attr.aria-label]="removeItemAriaLabel(item)"
              >
              <i class="ftmi-cross" aria-hidden="true"></i>
            </button>
          }
        </span>
      </li>
    }
  </ul>
}
@if (shouldShowDefaultMessage && this.selectedItems.length === 0 && shouldBeAbleToEditListGroupItem) {
  <div
    class="empty-list-message"
    role="status"
    aria-live="polite"
    >
    {{ defaultMessageContent | translate }}
  </div>
}
